import { Article, ArticleType } from '@wix/answers-api';

export enum HelpCenterError {
  MORE_INFORMATION_NEEDED = 'MORE_INFORMATION_NEEDED',
  NO_ARTICLES = 'NO_ARTICLES',
}

export type HelpCenterArticle = Pick<
  Article,
  'id' | 'title' | 'type' | 'url' | 'locale' | 'resolution' | 'resolutionEta'
>;

export interface HelpCenterVoteableArticle extends HelpCenterArticle {
  type: ArticleType.FEATURE_REQUEST | ArticleType.KNOWN_ISSUE;
}
